import { get } from '../netApi/fetch';
import { message, Modal } from 'antd';
import VIPPower from '../component/index/method/VIPPower';

// 配额数据接口
export interface QuotaData {
  daily_note: {
    used: number;
    limit: number;
    remaining: number;
    tip: string;
  };
  voice_note: {
    daily_used: number;
    daily_limit: number;
    daily_remaining: number;
    monthly_used_minutes: number;  // 已用分钟数（向上取整）
    monthly_used_seconds: number;  // 已用秒数（精确值）
    monthly_limit_minutes: number;  // 配额分钟数
    monthly_remaining_minutes: number;  // 剩余分钟数
    max_duration_seconds: number;
    max_duration_minutes: number;
    tip: string;
  };
  voice_to_text: {
    tip: string;
  };
  monthly_video: {
    monthly_used_minutes: number;  // 已用分钟数（向上取整）
    monthly_used_seconds: number;  // 已用秒数（精确值）
    monthly_limit_minutes: number;  // 配额分钟数
    monthly_remaining_minutes: number;  // 剩余分钟数
    video_count_this_month: number;
    total_video_generated: number;
    is_first_video_free: boolean;
    has_used_free_video: boolean;
    free_video_max_seconds: number;
    daily_limit: number;
    daily_used: number;
    daily_remaining: number;
    max_duration_seconds: number;
    tip: string;
  };
  storage: {
    limit_gb: number;
  };
  member_level: {
    id: number;
    level_name: string;
    level_type: number;
  };
}

/**
 * 获取用户配额信息
 */
export async function getQuotaInfo(): Promise<QuotaData> {
  try {
    const res = await get('/content/getquotaoverview', {});
    return res;
  } catch (error) {
    console.error('获取配额信息失败:', error);
    throw error;
  }
}

/**
 * 检查视频生成配额（带用户确认提示）
 * @returns Promise<boolean> 是否允许生成
 */
export async function checkVideoQuota(): Promise<boolean> {
  try {
    // 获取配额信息
    const quota = await getQuotaInfo();
    const videoQuota = quota.monthly_video;

    // 首次免费用户特殊处理 - 显示确认弹窗
    if (videoQuota.is_first_video_free) {
      return new Promise((resolve) => {
        Modal.info({
          title: '⭐ 首次免费视频体验',
          content: `您有 1次免费 视频生成体验（最长30秒）\n\n⚠️ 生成后将无法再次享受免费体验\n如需更多视频，请升级至「AI笔记-视频创作会员」`,
          okText: '我已知晓',
          onOk: () => resolve(true),
        });
      });
    }

    // 其他情况直接允许，由后端进行配额验证
    return true;
  } catch (error) {
    console.error('配额检查失败:', error);
    message.error('获取配额信息失败，请稍后重试');
    return false;
  }
}

/**
 * 检查语音转文字配额
 * @param audioDuration 音频时长（秒）
 * @returns Promise<boolean> 是否允许转换
 */
export async function checkVoiceToTextQuota(audioDuration: number): Promise<boolean> {
  // 语音转文字功能完全免费，直接返回 true
  return true;
}
